import IntegrationCallStateOverviewResourceModel from '../../generated/types/model/resource/IntegrationCallStateOverviewResourceModel';

export default class IntegrationCallStateOverviewResourceViewModel extends IntegrationCallStateOverviewResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
